import { AbstractControl, ValidationErrors } from '@angular/forms';

export const dateISO = (control: AbstractControl): ValidationErrors | null => {
  const key = 'dateISO';

  const value = control.value;

  if (!value) return null;

  const result =
    /^\d{4}[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/.test(value);

  if (!result) return { [key]: true };

  return null;
};
